import {
    TransactionColumn,
    TransactionView,
} from "@common/types/views/transactionViews";
import { NamedView, ViewType } from "@common/types/views/views";
import { FilterTabs } from "@components/pageHeader/filters/lib";

export const COUNTERPARTY_DRILL_DOWN_AVAILABLE_FILTERS: FilterTabs[] = [
    FilterTabs.DATE,
    FilterTabs.CATEGORY,
    FilterTabs.ACCOUNT,
    FilterTabs.AMOUNT,
];

export const createDefaultCounterpartyDrillDownTransactionView = ({
    isClassesEnabled,
}: {
    isClassesEnabled: boolean;
}): NamedView<TransactionView> => ({
    id: "counterparty-drilldown",
    name: "Counterparty drilldown",
    type: ViewType.TRANSACTION,
    options: {
        bulkActions: true,
        selection: true,
    },
    filters: {},
    columns: [
        { id: TransactionColumn.LOCK, options: { pin: "left" } },
        { id: TransactionColumn.DATE, options: { pin: "left" } },
        { id: TransactionColumn.SPLIT, options: { pin: "left" } },
        { id: TransactionColumn.BANK_DESCRIPTION },
        { id: TransactionColumn.COUNTERPARTY },
        { id: TransactionColumn.CATEGORY },
        ...(isClassesEnabled
            ? [{ id: TransactionColumn.CLASSES as const }]
            : []),
        { id: TransactionColumn.ACCOUNT },
        {
            id: TransactionColumn.AMOUNT,
            options: { pin: "right" },
        },
        {
            id: TransactionColumn.ENTITY,
            options: { pin: "right" },
        },
    ],
});
